// extracted by mini-css-extract-plugin
export default {"card":"styles_card__S9bZO","data":"styles_data__Uuy1q","label":"styles_label__xMv7h","value":"styles_value__4vXbt"};